/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { createCorePlayerBuilder } from './internal/CorePlayerBuilder';
import { CoreWebMafPlayerBuilder, WebMafPlayerBuilder } from './internal/CoreWebMafPlayerBuilder';
import { CoreUVPPlayerBuilder, UVPPlayerBuilder } from './internal/CoreUVPPlayerBuilder';
import { CoreJanusPlayerBuilder, JanusPlayerBuilder } from './internal/CoreJanusPlayerBuilder';
import { PlayerBuilder } from './PlayerBuilder';
import { Manifest } from './internal/Manifest';
import { ExternalPlayer } from './ExternalPlayer';
import { PlaybackOptions } from '@quickplay/player-interface';
import { createComposablePlayer } from './internal/ComposablePlayerImpl';
import { StringUtils, Uint8ArrayUtils, BufferUtils } from './shakaPlayer/internal/ShakaPlayerAdapter';
import { PlayerErrorCodes } from './PlayerErrorCodes';
import { ThumbnailPreviewConfig } from './thumbnailPreview/ThumbnailPreviewConfiguration';
import { createPromoPlayerBuilder } from './internal/PromoPlayerBuilderImpl';
import { PromoPlaybackPolicyHandler } from './internal/PromoPlayer/internal/policy/PromoPlaybackPolicyHandler';

export type { SidecarTrack } from './PlayerBuilder';
export { decodeCompanion } from './companion/CompanionDecoder';
export { createCompanionPresentation } from './companion/CompanionPresentation';
export type { CompanionPresentation, CompanionPresentationOptions } from './companion/CompanionPresentation';
export type {
  CompanionAction,
  CompanionActionOutcome,
  CompanionActionState,
  CompanionAdContext,
  CompanionDecodeResult,
  CustomCtaCreative,
  CompanionActions,
  CompanionConfiguration,
  CompanionEvent,
  CompanionFormat,
  CompanionNativeConfiguration,
  CompanionSize,
  CompanionTheme,
} from './companion/CompanionTypes';

const version = '__buildVersion__';

export {
  ExternalPlayer,
  PlaybackOptions,
  Manifest,
  PlayerBuilder,
  ThumbnailPreviewConfig,
  createComposablePlayer,
  version,
  createCorePlayerBuilder as createPlayerBuilder,
  CoreWebMafPlayerBuilder as createWebMafPlayerBuilder,
  CoreUVPPlayerBuilder as createUVPPlayerBuilder,
  CoreJanusPlayerBuilder as createJanusPlayerBuilder,
  Uint8ArrayUtils,
  StringUtils,
  BufferUtils,
  PlayerErrorCodes,
  UVPPlayerBuilder,
  WebMafPlayerBuilder,
  JanusPlayerBuilder,
  createPromoPlayerBuilder,
  PromoPlaybackPolicyHandler,
};

export { getAdfrequencyController } from './adfrequencyControl/AFCFactory';
export { createAFCPlaybackSessionManager } from './adfrequencyControl/AFCPlaybackSessionManager';
export { adFrequencyEventPublisher } from './adfrequencyControl/EventBus';
export type {
  AdBreakProgress,
  AdFrequencyControlConfiguration,
  AdFrequencyController,
  AdFrequencyDecision,
  AdFrequencyDecisionReason,
  AdFrequencyEvent,
  AdFrequencyEventPublisher,
} from './adfrequencyControl/types';
export type { AFCPlaybackSession, AFCPlaybackSessionOptions } from './adfrequencyControl/AFCPlaybackSessionManager';
export { AdIncomingNotifier, AdIncomingEvent } from './adIncoming/AdIncomingNotifier';
